<template>
  <div>
    <Header />
    <div class="main-content">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./Header"
import Footer from "./Footer"

export default {
  name: "MainLayout",
  components: {
    Header,
    Footer,
  },
}
</script>

<style scoped>
.main-content {
  padding-top: 2rem;
  background-color: #fafafa;
  padding-bottom: 3rem;
  min-height: 500px;
}
</style>
